import React, { Fragment, memo } from 'react'
import styled from 'styled-components'
import { Currency, Trade, TradeType } from '@nominex/nomiswap-sdk'
import { ChevronRightIcon } from '@nominex/dex-uikit'
import { unwrappedToken } from 'utils/wrappedCurrency'

const StyledChevronContainer = styled.div`
  align-items: center;
  background: ${({ theme }) => theme.colors.blue500}33;
  border-radius: 100%;
  display: flex;
  height: 16px;
  justify-content: center;
  margin-left: 6px;
  margin-right: 6px;
  width: 16px;
`

export default memo(({ trade }: { trade: Trade<Currency, Currency, TradeType> }) => (
  <div className="flex flex-wrap items-center justify-end w-[100%]">
    {trade.route.path.map((token, i, path) => {
      const isLastItem: boolean = i === path.length - 1
      const currency = unwrappedToken(token)
      return (
        // eslint-disable-next-line react/no-array-index-key
        <Fragment key={i}>
          <div className="flex items-end">
            <div className="text-white text-14 mx-[0.125rem] notranslate" translate="no">
              {currency.symbol}
            </div>
          </div>
          {!isLastItem && (
            <StyledChevronContainer>
              <ChevronRightIcon color="blue500" width="16px" />
            </StyledChevronContainer>
          )}
        </Fragment>
      )
    })}
  </div>
))
